import React from 'react'
import { connect } from 'react-redux'
import { localized } from '@/decorators/localized'
import { Main, MainTop, MainTopLeft, MainTopTitle, MainBody } from '@/components/Layout'
import Resx from '@/components/Resx'
import context from '@/context'
import { BsrsGrid, commandColumnProps } from '@/components/BsrsGrid'
import { GridColumn as Column } from '@progress/kendo-react-grid'
import Icon from '@/components/Icon'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'
import { withPermissions } from '@/decorators/withPermissions'

const mapStateToProps = (state) => {
  return {
    ...state.institutionGroups
  }
}

const mapDispatchToProps = {
  openDialog: dialogActions.openDialog
}

@localized()
@withPermissions()
@connect(mapStateToProps, mapDispatchToProps)
class InstitutionGroups extends React.Component {
  openDialog (id, title) {
    this.props.openDialog({
      dialogType: dialogTypes.institutionGroup,
      primaryButtonText: 'Common.SaveAndClose',
      title,
      id,
      disabled: !this.canManage()
    })
  }
  canManage = () => this.props.isGranted('CanManageInstitutionGroups')
  render () {
    const { localize, gridKey } = this.props
    const canManage = this.canManage()

    return (
      <React.Fragment>
        <Main>
          <MainTop>
            <MainTopTitle>
              <Resx name='Institutions.InstitutionGroups' />
            </MainTopTitle>
            <MainTopLeft>
              {canManage && <button onClick={() => this.openDialog(0, 'Institutions.AddGroupTitle')} className='btn btn-primary btn-sm'>
                <Icon name='plus' />
                <span><Resx name='Institutions.AddGroup' /></span>
              </button>}
            </MainTopLeft>
          </MainTop>
          <MainBody>
            <BsrsGrid persistenceId={'institution-groups'} dataSource={context.api.institutionGroupService.getTableData} lastReloadedAt={gridKey}>
              <Column field='name' title={localize('Common.ArabicName')} editable={false} />
              <Column field='latinName' title={localize('Common.LatinName')} editable={false} />
              <Column {...commandColumnProps({ onDetailClick: dataItem => this.openDialog(dataItem.id, 'Institutions.EditGroup') })} />
            </BsrsGrid>
          </MainBody>
        </Main>
      </React.Fragment>
    )
  }
}

export { InstitutionGroups }



// WEBPACK FOOTER //
// ./src/internal-app/pages/institutionGroups/list.js